import { useCallback } from 'react';
import { analytics } from '@/lib/analytics';
import { useOrgStore } from '@/stores/org-store';

export const useAnalytics = () => {
  const { currentOrg } = useOrgStore();

  const track = useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      analytics.capture(event, {
        ...properties,
        org_id: currentOrg?.orgid,
        org_name: currentOrg?.name,
      });
    },
    [currentOrg],
  );

  return { track };
};
